import React, { useRef } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import Home from "./screens/Home";
import "./App.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Contact from "./screens/Contact";
import Terms from "./screens/Terms";
import PrivacyPolicy from "./screens/PrivacyPolicy";
import Pricing from "./screens/Pricing";

import Onboarding from "./screens/Onboarding-b2c";
import OnboardingB from "./screens/Onboarding-b2b";
import OnboardingUnits from "./screens/Onboarding-units";
import OnboardingTeam from "./screens/Onboarding-team";

import AttendantGuidInEnglish from "./screens/Attendantguide-english";
import ValentGuideEnglish from "./screens/Valetguide-english";
import BellStaffGuideEnglish from "./screens/Bellstaffguide-english";

import AttendantGuidInSpanish from "./screens/Attendantguide-spanish";
import ValentGuideSpanish from "./screens/Valetguide-spanish";
import BellStaffGuideSpanish from "./screens/Bellstaffguide-spanish";

import DemoScreen from "./screens/DemoScreen";

import { FAQDetail } from "./screens/FAQ";
import FAQGallery from "./screens/FAQ/cards";
import SalesDeck from "./screens/SalesDeck";
import TipkitParksDeck from "./screens/TipkitParksDeck";
import TipkitOnePager from "./screens/TipkitOnePager";

function App() {
  const innovationRef = useRef(null);
  const trinityRef = useRef(null);

  const location = useLocation();

  const hideLayoutRoutes = [
    "/onboard-your-hotel-b2c",
    "/onboard-your-hotel-b2b",
    "/onboard-your-units",
    "/onboard-your-team",
    "/room-attendant-guide-english",
    "/valet-guide-english",
    "/bellstaff-guide-english",
    "/sales-deck",
    "/tipkit-parks-deck",
    "/tipkit-one-pager",
  ];

  const shouldHideLayout =
    hideLayoutRoutes.includes(location.pathname) ||
    location.pathname.startsWith("/demo");

  return (
    <div className="min-h-screen flex flex-col">
      {!shouldHideLayout && (
        <Navbar innovationRef={innovationRef} trinityRef={trinityRef} />
      )}

      <div className="flex-grow">
        <Routes>
          <Route
            path="/"
            element={
              <Home innovationRef={innovationRef} trinityRef={trinityRef} />
            }
          />

          <Route path="/contact" element={<Contact />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/faq" element={<FAQGallery />} />
          <Route path="/faq/:id" element={<FAQDetail />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          <Route path="/onboard-your-hotel-b2c" element={<Onboarding />} />
          <Route path="/onboard-your-hotel-b2b" element={<OnboardingB />} />
          <Route path="/onboard-your-units" element={<OnboardingUnits />} />
          <Route path="/onboard-your-team" element={<OnboardingTeam />} />

          <Route
            path="/room-attendant-guide-english"
            element={<AttendantGuidInEnglish />}
          />
          <Route path="/valet-guide-english" element={<ValentGuideEnglish />} />
          <Route
            path="/bellstaff-guide-english"
            element={<BellStaffGuideEnglish />}
          />

          <Route
            path="/room-attendant-guide-spanish"
            element={<AttendantGuidInSpanish />}
          />
          <Route path="/valet-guide-spanish" element={<ValentGuideSpanish />} />
          <Route
            path="/bellstaff-guide-spanish"
            element={<BellStaffGuideSpanish />}
          />

          <Route
            path="/demo/b2c/attendants"
            element={<DemoScreen target="b2cAttendants" />}
          />
          <Route
            path="/demo/b2c/valet"
            element={<DemoScreen target="b2cValets" />}
          />
          <Route
            path="/demo/b2c/belldesk"
            element={<DemoScreen target="b2cBellmen" />}
          />

          <Route
            path="/demo/b2b/attendants"
            element={<DemoScreen target="b2bAttendants" />}
          />
          <Route
            path="/demo/b2b/valet"
            element={<DemoScreen target="b2bValets" />}
          />
          <Route
            path="/demo/b2b/belldesk"
            element={<DemoScreen target="b2bBellmen" />}
          />

          <Route path="/sales-deck" element={<SalesDeck />} />
          <Route path="/tipkit-parks-deck" element={<TipkitParksDeck />} />
          <Route path="/tipkit-one-pager" element={<TipkitOnePager />} />
        </Routes>
      </div>

      {!shouldHideLayout && <Footer />}
    </div>
  );
}

export default App;
